import Button from "antd/es/button"
import Empty from "antd/es/empty"
import Skeleton from "antd/es/skeleton"
import { collection, limit, orderBy, query } from "firebase/firestore"
import { useCollectionData } from "react-firebase-hooks/firestore"
import { useNavigate } from "react-router"

import Header from "../components/Header"
import { useActiveUserAuthorizationFromContext } from "../contexts/ActiveUserAuthorizationContext"
import { makeConverter } from "../dbUtils"
import { db } from "../firebaseApp"
import NotificationItem from "../notifications/NotificationItem"
import type { Notification } from "../notifications/types"

const NotificationsPage: React.FC = () => {
  const navigate = useNavigate()
  const { authUser } = useActiveUserAuthorizationFromContext()
  const [notifications, notificationLoading] = useCollectionData(
    query(
      collection(db, "users", authUser.uid, "notifications"),
      orderBy("created_at", "desc"),
      limit(500),
    ).withConverter(makeConverter<Notification>()),
  )

  const noNotifications = (
    <Empty
      image={Empty.PRESENTED_IMAGE_SIMPLE}
      description="You don't have any notifications yet"
    />
  )

  return (
    <>
      <Header title="Notifications">
        <Button
          onClick={() => navigate("/profile/notification-preferences")}
          type="primary"
        >
          Preferences
        </Button>
      </Header>
      <div className="w-full">
        <div className="flex max-w-[600px] flex-col gap-2 p-4">
          <Skeleton
            className="rounded-lg p-4 shadow"
            active
            avatar
            loading={notificationLoading}
            paragraph={{ rows: 1 }}
          >
            {!notifications || notifications.length === 0
              ? noNotifications
              : notifications.map((notification) => (
                  <NotificationItem
                    key={notification.oid}
                    notification={notification}
                    user={authUser}
                  />
                ))}
          </Skeleton>
          <Skeleton
            className="rounded-lg p-4 shadow"
            active
            avatar
            loading={notificationLoading}
            paragraph={{ rows: 1 }}
          />
        </div>
      </div>
    </>
  )
}

export default NotificationsPage
